import React from 'react'
import { Button, Form, Divider, Card, Menu, Icon, Grid, Header, Image, Message, Segment } from 'semantic-ui-react'
import {  Link } from 'react-router-dom'
import { Authenticator } from '@aws-amplify/ui-react';


const SidebarIzquierda = ({cerrarSesion, fotoPerfil,strings=[], onShowModalPerfil}) => (
         <Segment  basic >
 
        
                <Grid textAlign="center" className="app" columns={1} >
                    <Grid.Row  >
                      <Grid.Column>
   
                        <Authenticator >
                            {({ signOut, user }) => (
                               <Card>
                                <Image src={fotoPerfil} wrapped ui={false} />
                                <Card.Content>
                                  <Card.Header>{user.username}</Card.Header>
                                   
                                   <Card.Meta>
                                                                          
                                   
                                    <Link to="/completar">
                                    <Button icon="user" size="mini" color="teal"></Button>
                                    </Link>    
    <Button icon="photo"  size ="mini" onClick={onShowModalPerfil} color="pink">
                                            </Button>
                                        
                                    </Card.Meta>
    
                                    
                                </Card.Content>

                              </Card> 
                            )}
                        </Authenticator>
        
                      </Grid.Column>
                    </Grid.Row>
                     
              </Grid>
        </Segment>
)

export default SidebarIzquierda